module.exports = __webpack_public_path__ + "static/img/hh-prepared.ef6c8584.png";